// The nudge: one card with the current level's words, under the grid (above the pad). Each
// press goes one level deeper on the same step; the last level applies it.
import type { NudgeAnswer } from '@zinc/shared';

export function NudgeCard(props: {
  answer: NudgeAnswer;
  /** 1–3: the levels with words; the next press applies (level 4). */
  level: number;
  onMore: () => void;
  onClose: () => void;
}) {
  const { answer, level } = props;
  const text = answer.levels[level - 1]?.text ?? '';
  const last = level >= answer.levels.length;
  return (
    <section
      aria-label="Nudge"
      aria-live="polite"
      className="mx-3 flex flex-col gap-2 rounded-[12px] border border-line bg-surface px-3 py-2.5 lg:mx-0"
    >
      <div className="flex items-center gap-2 text-[13px]">
        <span className="font-semibold">Nudge</span>
        <span className="text-muted">
          {level} of {answer.levels.length + 1}
        </span>
        <button
          type="button"
          aria-label="Close the nudge"
          onClick={props.onClose}
          className="ml-auto flex h-8 w-8 items-center justify-center rounded-btn border-0 bg-transparent text-[18px] text-muted"
        >
          ×
        </button>
      </div>
      <p className="m-0 text-[14px] leading-snug text-ink" data-testid="nudge-text">
        {text}
      </p>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={props.onMore}
          className="h-10 rounded-btn border border-line bg-surface px-4 text-[14px] font-semibold text-ink"
        >
          {last ? (answer.kind === 'mistake' ? 'Clear it' : 'Apply it') : 'Tell me more'}
        </button>
      </div>
    </section>
  );
}
